package br.com.vvrefeicoes.portal.domain.model

data class UserDocument(
    val id: String,
    val originalFileName: String,
    val source: String,
    val contentType: String,
    val sizeBytes: Long,
)

enum class UserDocumentType(
    val source: String,
    val label: String,
) {
    ASSINATURA("ASSINATURA", "Assinatura"),
}

val availableUserDocumentTypes = UserDocumentType.entries
